import React from "react";

const VideoPlayer = ({ video }) => {
  const videoSrc = `https://www.youtube.com/embed/${video.id.videoId}`;

  return (
    <div className="video-player">
      <iframe
        title="YouTube Player"
        width="100%"
        height="400"
        src={videoSrc}
        allowFullScreen
        className="rounded"
      />
      <h2 className="text-xl font-bold mt-2">{video.snippet.title}</h2>
      <p className="text-sm text-gray-600">{video.snippet.description}</p>
    </div>
  );
};

export default VideoPlayer;
